// extracted by mini-css-extract-plugin
module.exports = {"small":"s2Bd","medium":"s2XP","large":"s24Y","auto":"s3PA"};